import React, { useState } from "react";
import SshUsernameField from "./SshUsernameField";
import SshPasswordField from "./SshPasswordField";
import SshPasswordlessKeyFeild from "./SshPasswordlessKeyField";
import CheckConnectionSection from "./CheckConnectionSection";
import { showInfoToast } from "../../validation/ToastContainer";
//import { ConnectionTypes } from "../add-device-modal/ConnectionTypeSection";
import WinRmUsernameField from "./WinRmUsernameField";
import WinRmPasswordField from "./WinRmPasswordField";
import DomainField from "./DomainField";
import DomainSetField from "./DomainSetField";
import PowerCLIUsernameField from "./PowerCLIUsernameField";
import PowerCLIPasswordField from "./PowerCLIPasswordField";
import EnablePasswordTextField from "./EnablePasswordTextField";
import HealthMonitorIntervalField from "./HealthMonitorIntervalField";
import ApiKeyField from "./ApiKeyField";
import ApiUrlField from "./ApiUrlField";
import ApiUsernameField from "./ApiUsernameField";
import ApiPasswordField from "./ApiPasswordField";
import ApiMonitorUriField from "./ApiMonitorUriField";
import ConnectionTypeRadio from "./ConnectionTypeRadio";
import CentralCredentialsField from "./CentralCredentialsField";
import WinrmHttpsField from "./WinrmHttpsField";
import MSClientIdField from "./MSClientIdField";
import MSTenantIdField from "./MSTenantIdField";
import { uploadWinrmHttpsCertificate } from "../deviceService";
import { showSuccessToast, showDangerToast } from "../../validation/ToastContainer";
import * as deviceService from "../deviceService";

// import ApiConnectionFieldset from "./ApiConnectionFieldset";
// import SshConnectionFieldset from "./SshConnectionFieldset";
// import AnsibleConnectionFieldset from "./WinRmConnectionFieldset";
// import PowerCLIConnectionFieldset from "./PowerCLIConnectionFieldset";

export const ConnectionTypes = {
    API: 'API',
    SSH: 'SSH',
    WINRM: 'WINRM',
    //LOG_FILE: 'LOG_FILE',
    PowerCLI: 'PowerCLI',
    M365: 'M365'
}

function ConnectivitySection({ device, onDeviceChange, deviceMetadata, onDeviceMetadataChange, disabled }) {

    const [loading, setLoading] = useState(false);
    const [editDomain, setEditDomain] = useState(false);    

    // const getConnectionTypeFieldset = () => {
    //     switch (device.connectionType) {
    //         case ConnectionTypes.API:
    //             return <ApiConnectionFieldset disabled={disabled} />
    //         case ConnectionTypes.SSH:
    //             return <SshConnectionFieldset disabled={disabled} />
    //         case ConnectionTypes.WINRM:
    //             return <AnsibleConnectionFieldset disabled={disabled} />
    //         // case ConnectionTypes.LOG_FILE:
    //         //     return <LogFileConnectionFieldset disabled={disabled}/>
    //         case ConnectionTypes.PowerCLI:
    //             return <PowerCLIConnectionFieldset disabled={disabled} />
    //         default:
    //             return <ApiConnectionFieldset disabled={disabled} />
    //     }
    // }

    const onChangePasswordClick = () => {
        if (!loading) {
            onDeviceMetadataChange({ passwordChanged: true, connected: false });
            onDeviceChange({
                sshPassword: "", sshPasswordlessKey: "", winrmPassword: "",
                enablePassword: "", powerCliPassword: "", apiKey: "", apiUsername: "", apiPassword: ""
            })

            // onDeviceChange({sshPassword: device.sshPassword, sshPasswordlessKey: device.sshPasswordlessKey, winrmPassword: device.winrmPassword,enablePassword:device.enablePassword})
        } else {
            showInfoToast("Wait for connection status", "Change credentials");
        }
    }

    const onConnectedChange = (value) => {
        onDeviceMetadataChange({ connected: value })
    }

    // const onHealthMonitorIntervalChange = (value) => {
    //     onDeviceChange({ healthMonitorInterval: value })
    // }


    //#region SSH
    const onSshUsernameChange = (value) => {
        onDeviceChange({ sshUsername: value });
        onDeviceMetadataChange({ connected: null, connectionDataChanged: true })
        onDeviceMetadataChange({ passwordChanged: true });
    }
    const onSshPasswordChange = (value) => {
        onDeviceChange({
            sshPassword: value,
            sshPasswordlessKey: '',
            passwordChanged: true
        })
    }
    const onSshPasswordlessKeyChange = (value) => {
        onDeviceChange({
            sshPasswordlessKey: value,
            sshPassword: '',
            passwordChanged: true
        })
    }

    const onCheckEnabledPasswordChange = (value) => {

        onDeviceChange({
            hasEnabledPassword: value

        })


    }
    const onEnablePasswordChange = (value) => {
        onDeviceChange({
            enablePassword: value,
            passwordChanged: true
        })
    }
    //#endregion


    //#region PowerCLI
    //Added by Octopus DevTeam Sep 2,2022
    const onPowerCLIUsernameChange = (value) => {
        onDeviceChange({ powerCliUsername: value });
        onDeviceMetadataChange({ connected: null, connectionDataChanged: true })
    }
    const onPowerCLIPasswordChange = (value) => {
        onDeviceChange({
            powerCliPassword: value,

            passwordChanged: true
        })
    }
    //#endregion


    //#region API
    const onApiUrlChange = (value) => {
        onDeviceChange({ apiUrl: value });
        onDeviceMetadataChange({ connected: null, connectionDataChanged: true })
    }
    const onApiKeyChange = (value) => {
        onDeviceChange({
            apiKey: value,
            apiUsername: '',
            apiPassword: '',
            passwordChanged: true
        })
    }
    const onApiUsernameChange = (value) => {
        onDeviceChange({
            apiUsername: value,
            apiKey: '',
            passwordChanged: true
        })
    }
    const onApiPasswordChange = (value) => {
        onDeviceChange({
            apiPassword: value,
            apiKey: '',
            passwordChanged: true
        })
    }
    //#endregion


    //#region WinRM
    const onWinRmUsernameChange = (value) => {
        onDeviceChange({ winrmUsername: value });
        onDeviceMetadataChange({ connected: null, connectionDataChanged: true })
    }
    const onWinRmPasswordChange = (value) => {
        onDeviceChange({
            winrmPassword: value,
            passwordChanged: true
        })
    }
    const onDomainChange = (value) => {
        onDeviceChange({ domain: value })
    }
    const onDomainSetChange = (value) => {
        //onDeviceChange({ domainSet: value })
        setEditDomain(value);
    }

    const renderConnectivityActions = () => (
        <div className="modal-v2-form-step2 edit-device-connectivity-step2">
            <div className="modal-v2-step2-shell">
                <div className="modal-v2-step2-status-card">
                    <CheckConnectionSection modalData={device}
                        passwordChanged={deviceMetadata.passwordChanged}
                        connected={deviceMetadata.connected}
                        setConnected={onConnectedChange}
                        loading={loading}
                        setLoading={setLoading}
                        disabled={disabled} />
                </div>
            </div>
            <div className="edit-device-connectivity-monitor">
                <HealthMonitorIntervalField value={device.healthMonitorInterval}
                    onChange={(value) => onDeviceChange({ healthMonitorInterval: value })}
                    disabled={disabled} />
            </div>
        </div>
    );

    const onWinRmHttpsChange = (value) => {
        onDeviceChange({winrmhttps: value})
        // if (!value) {
        //     onDeviceChange({ httpsCertFilePath: '' });
        // }
    }

    const onfileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            uploadWinrmHttpsCertificate(file)
            .then(filePath => {
                if (filePath) {
                    showSuccessToast("Certificate Uploaded", "Https Certificate");
                    onDeviceChange({ httpsCertFilePath: filePath });
                    //modalDataService.changeHttpsCertificatePath(filePath);                    
                } else {
                    showDangerToast("Upload failed: no file path returned", "Error");
                }
            })
            .catch(err => {
                // Catches the thrown error from !response.ok
                showDangerToast(err.message, "Error");
            });
        }
        event.target.value = null; // reset input so onChange fires again next time
    };

    const getWinRmFieldsSet = () => {
        return (
            <>
                <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-ssh">
                    <DomainSetField value={editDomain}
                        onChange={onDomainSetChange}
                        disabled={disabled} />
                    <DomainField value={device.domain?.id}
                        domains={deviceMetadata.domains}
                        onChange={onDomainChange}
                        disabled={!editDomain} />
                    <CentralCredentialsField centralCredentials={deviceMetadata.centralCredentials}
                        value={device.centralCredential?.id}
                        onChange={onCentralCredentialChange}
                        disabled={disabled} />
                    <div className="row modal-v2-auth-grid">
                        <div className="col-md-6 modal-v2-auth-col">
                            <WinRmUsernameField value={device.winrmUsername}
                                onChange={onWinRmUsernameChange}
                                centralCredentialId={device.centralCredential?.id}
                                disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-auth-col">
                            <WinRmPasswordField value={device.winrmPassword}
                                onChange={onWinRmPasswordChange}
                                passwordChanged={deviceMetadata.passwordChanged}
                                onChangePasswordClick={onChangePasswordClick}
                                centralCredentialId={device.centralCredential?.id}
                                disabled={disabled} />
                        </div>
                        <div className="col-12 modal-v2-auth-col">
                            <WinrmHttpsField  value={device.winrmhttps}
                                onChange={onWinRmHttpsChange}
                                onfileChange={onfileChange}
                                disabled={disabled} />
                        </div>
                    </div>
                </fieldset>
                {renderConnectivityActions()}
            </>
        )
    }
    //#endregion

    //#region M365
    const onMSTenantIdChange = (value) => {
        onDeviceChange({ msTenantId: value });
        onDeviceMetadataChange({ connected: null, connectionDataChanged: true })
    }

    const onMSClientIdChange = (value) => {
        onDeviceChange({ msClientId: value });
        onDeviceMetadataChange({ connected: null, connectionDataChanged: true })
    }

    const onMSSubjectChange = (value) => {
        onDeviceChange({ msSubject: value });
        onDeviceMetadataChange({ connected: null, connectionDataChanged: true })
    }

    const generateCertificate = async() => {
        const hostName = device.hostName;
        const msSubject = device.msSubject;
        await deviceService.generateMSCertificate(hostName, msSubject);
    };

    //#endregion


    const onCentralCredentialChange = (value) => {
        if (!loading) {
            onDeviceMetadataChange({ passwordChanged: true, connected: false });
            onDeviceChange({
                centralCredential: value,
                sshPassword: "", sshPasswordlessKey: "", winrmPassword: "",
                enablePassword: "", powerCliPassword: "", apiKey: "", apiUsername: "", apiPassword: ""
            })

            // onDeviceChange({sshPassword: device.sshPassword, sshPasswordlessKey: device.sshPasswordlessKey, winrmPassword: device.winrmPassword,enablePassword:device.enablePassword})
        } else {
            showInfoToast("Wait for connection status", "Change credentials");
        }

        // onDeviceChange({ centralCredential: value });
        // onDeviceMetadataChange({ passwordChanged: true });
        // onDeviceMetadataChange({ connected: null, connectionDataChanged: true });
    };

    const getSshFieldSet = () => {
        return (
            <>
                <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-ssh">
                    <CentralCredentialsField centralCredentials={deviceMetadata.centralCredentials}
                        value={device.centralCredential?.id}
                        onChange={onCentralCredentialChange}
                        disabled={disabled} />
                    <div className="row modal-v2-auth-grid">
                        <div className="col-md-6 modal-v2-auth-col">
                            <SshUsernameField value={device.sshUsername}
                                onChange={onSshUsernameChange}
                                centralCredentialId={device.centralCredential?.id}
                                disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-auth-col">
                            <SshPasswordField value={device.sshPassword}
                                onChange={onSshPasswordChange}
                                passwordChanged={deviceMetadata.passwordChanged}
                                onChangePasswordClick={onChangePasswordClick}
                                anotherSectionActive={!!device.sshPasswordlessKey}
                                centralCredentialId={device.centralCredential?.id}
                                disabled={disabled} />
                        </div>
                    </div>
                    <div className="form-group modal-v2-enable-password-group">
                        <div className="modal-v2-enable-password-heading">Enable Password</div>
                        <div className="oct_check modal-v2-enable-password-check-v2">
                            <label className="oct_check-label">
                                <input type="checkbox"
                                    checked={!!device.hasEnabledPassword}
                                    disabled={disabled}
                                    onChange={disabled ? null : () => onCheckEnabledPasswordChange(!device.hasEnabledPassword)} />
                                <span>Has Enable Password</span>
                            </label>
                        </div>
                        {device.hasEnabledPassword ? <EnablePasswordTextField value={device.enablePassword}
                            onChange={onEnablePasswordChange}
                            passwordChanged={deviceMetadata.passwordChanged}
                            onChangePasswordClick={onChangePasswordClick}
                        /> : null}
                    </div>
                    <p className="modal-v2-or-divider">OR</p>
                    <SshPasswordlessKeyFeild value={device.sshPasswordlessKey}
                        onChange={onSshPasswordlessKeyChange}
                        passwordChanged={deviceMetadata.passwordChanged}
                        onChangePasswordClick={onChangePasswordClick}
                        anotherSectionActive={!!device.sshPassword}
                        centralCredentialId={device.centralCredential?.id}
                        disabled={disabled} />
                </fieldset>
                {renderConnectivityActions()}
            </>
        )
    }

    const getPowerCLIFieldSet = () => {
        return (
            <>
                <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-ssh">
                    <CentralCredentialsField centralCredentials={deviceMetadata.centralCredentials}
                        value={device.centralCredential?.id}
                        onChange={onCentralCredentialChange}
                        disabled={disabled} />
                    <div className="row modal-v2-auth-grid">
                        <div className="col-md-6 modal-v2-auth-col">
                            <PowerCLIUsernameField value={device.powerCliUsername}
                                onChange={onPowerCLIUsernameChange}
                                centralCredentialId={device.centralCredential?.id}
                                disabled={disabled} />
                        </div>
                        <div className="col-md-6 modal-v2-auth-col">
                            <PowerCLIPasswordField value={device.powerCliPassword}
                                onChange={onPowerCLIPasswordChange}
                                passwordChanged={deviceMetadata.passwordChanged}
                                onChangePasswordClick={onChangePasswordClick}
                                centralCredentialId={device.centralCredential?.id}
                                disabled={disabled} />
                        </div>
                    </div>
                </fieldset>
                {renderConnectivityActions()}
            </>
        )
    }

    const getAPIFieldSet = () => {
        return (
            <>
                <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-api">
                    <div className="modal-v2-api-sections">
                        <div className="modal-v2-api-subsection modal-v2-api-subsection--endpoints">
                            <div className="modal-v2-api-subsection__header">
                                <h4 className="modal-v2-api-subsection__title">Endpoint Details</h4>
                                <p className="modal-v2-api-subsection__caption">Enter the API URL and monitor path first.</p>
                            </div>
                            <ApiUrlField value={device.apiUrl}
                                onChange={onApiUrlChange}
                                disabled={disabled} />
                            <ApiMonitorUriField value={device.apiMonitorUri}
                                onChange={(value) => onDeviceChange({ apiMonitorUri: value })}
                                disabled={disabled} />
                        </div>

                        <div className="modal-v2-api-subsection modal-v2-api-subsection--credentials">
                            <div className="modal-v2-api-subsection__header">
                                <h4 className="modal-v2-api-subsection__title">Authentication</h4>
                                <p className="modal-v2-api-subsection__caption">Use either an API key or a username and password.</p>
                            </div>
                            <ApiKeyField value={device.apiKey}
                                onChange={onApiKeyChange}
                                anotherSectionActive={!!device.apiUsername || !!device.apiPassword}
                                apiKeyChanged={deviceMetadata.passwordChanged}
                                onChangeApiKeyClick={onChangePasswordClick}
                                disabled={disabled} />
                            <p className="modal-v2-or-divider modal-v2-or-divider--tight">OR</p>
                            <div className="row modal-v2-auth-grid">
                                <div className="col-md-6 modal-v2-auth-col">
                                    <ApiUsernameField value={device.apiUsername}
                                        onChange={onApiUsernameChange}
                                        anotherSectionActive={!!device.apiKey}
                                        passwordChanged={deviceMetadata.passwordChanged}
                                        onChangeApiUsernameClick={onChangePasswordClick}
                                        disabled={disabled} />
                                </div>
                                <div className="col-md-6 modal-v2-auth-col">
                                    <ApiPasswordField value={device.apiPassword}
                                        onChange={onApiPasswordChange}
                                        anotherSectionActive={!!device.apiKey}
                                        passwordChanged={deviceMetadata.passwordChanged}
                                        onChangeApiPasswordClick={onChangePasswordClick}
                                        disabled={disabled} />
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                {renderConnectivityActions()}
            </>
        )
    }

    const getMSFieldSet = () => {
        return (
            <>
                <fieldset className="oct_fieldset oct_fieldset-inner">
                    <div className="row modal-v2-form-grid">
                        <div className="col-md-7 modal-v2-grid-field">
                            <div className="form-group">
                                <div className="oct_form-group oct_form-sm">
                                    <label htmlFor="ms_subject">Subject <span className="modal-v2-required-mark">*</span></label>
                                    <input className='form-control oct_field'
                                        id="ms_subject-key"
                                        disabled={disabled}
                                        value={device.msSubject}                                      
                                        onChange={event => onMSSubjectChange(event.target.value)} />
                                    <div className="modal-v2-field-help">Default: VarApp/O=MyCompany/C=US</div>
                                </div >                
                            </div>
                        </div>
                        <div className="col-md-5 modal-v2-grid-field">
                            <div className="form-group">
                                <div className="oct_form-group oct_form-sm">
                                    <label className="d-none d-md-block">&nbsp;</label>
                                    {/* <button className="oct_settings-btn-v2" */}
                                    <button className="btn modal-v2-btn modal-v2-btn-primary w-100"
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            generateCertificate();
                                        }} 
                                        
                                    >
                                        Generate & Download Certificate
                                    </button>
                                </div>
                            </div>
                        </div> 
                    </div>
                                    
                    
                    <MSTenantIdField value={device.msTenantId}
                                    onChange={onMSTenantIdChange}
                                    disabled={disabled} />
                    <MSClientIdField value={device.msClientId}
                                    onChange={onMSClientIdChange}
                                    disabled={disabled} /> 
                            
                </fieldset>
                {renderConnectivityActions()}
            </>
        )
    }

    return (
        <>
            <ConnectionTypeRadio connectionType = {device.connectionType}
                                disabled={disabled} />

            {device.connectionType === ConnectionTypes.SSH ? getSshFieldSet() :
                device.connectionType === ConnectionTypes.PowerCLI ? getPowerCLIFieldSet() :
                    device.connectionType === ConnectionTypes.API ? getAPIFieldSet() :
                    device.connectionType === ConnectionTypes.WINRM ? getWinRmFieldsSet() :
                    getMSFieldSet()}
        </>
    )

}

export default ConnectivitySection;
